export default __webpack_public_path__ + "static/media/proxysql.4770daa8.png";